import { getDefaultField, getEditable } from 'pages/ContactsPage/columns';
import React from 'react';
import { DEFAULT_FIELD_NAMES } from 'utility/constants';

export const getNextField = (
  {
    columnSettings,
    getColumns,
    fields,
    model,
    teams,
    businessTimezone,
    t,
    preReleaseFeatures,
  },
  creationFieldId,
  currentId
) => {
  const columnIds = getColumns({
    fields,
    columnSettings,
    model,
    teams,
    businessTimezone,
    preReleaseFeatures,
    t,
  })
    .filter((c) => c?.meta?.editable)
    .map(({ id }) => id);
  if (!columnIds.length) {
    return null;
  }
  if (currentId) {
    const currentIndex = columnIds.indexOf(currentId);

    if (currentIndex + 1 >= columnIds.length) {
      return null;
    }

    return columnIds[currentIndex + 1];
  }
  return creationFieldId;
};

export const cloneFormattedElement = (fn, props) => {
  if (!fn) {
    return fn;
  }
  return (...args) => {
    const el = fn(...args);
    if (!el) {
      return el;
    }
    return React.cloneElement(el, props);
  };
};

export const getDefaultNewRecord = (owner, id = 'new') => ({
  id,
  fields: [],
  access: { view: true, edit: true },
  owner,
});

export const getCreationFieldIds = ({ fields, model }) => {
  if (model.name === 'client_client') {
    const firstNameField = getDefaultField(
      DEFAULT_FIELD_NAMES.firstName,
      fields
    );

    if (getEditable(firstNameField)) {
      return [DEFAULT_FIELD_NAMES.firstName, DEFAULT_FIELD_NAMES.email];
    }

    return [DEFAULT_FIELD_NAMES.email, DEFAULT_FIELD_NAMES.email];
  }

  return [DEFAULT_FIELD_NAMES.name, DEFAULT_FIELD_NAMES.name];
};
